/* Button to enter swipe/triage mode from the feed page. Text + icon, prominent but not fully primary. */

import { Button } from "@/components/ui/button";
import type { LucideIcon } from "lucide-react";
import { Shuffle, Play, GalleryHorizontalEnd, Layers } from "lucide-react";
import { cn } from "@/lib/utils";

type SwipeModeVariant =
  | "outline-shuffle"
  | "outline-play"
  | "outline-cards"
  | "outline-layers"
  | "soft-shuffle"
  | "soft-play"
  | "soft-cards"
  | "soft-layers";

interface SwipeModeButtonProps {
  onClick: () => void;
  variant?: SwipeModeVariant;
  label?: string;
  className?: string;
}

const ICONS: Record<string, LucideIcon> = {
  shuffle: Shuffle,
  play: Play,
  cards: GalleryHorizontalEnd,
  layers: Layers,
};

export function SwipeModeButton({
  onClick,
  variant = "outline-shuffle",
  label = "Swipe Mode",
  className,
}: SwipeModeButtonProps) {
  const [style, iconName] = variant.split("-") as [string, string];
  const Icon = ICONS[iconName];

  if (style === "soft") {
    return (
      <Button
        variant="ghost"
        onClick={onClick}
        className={cn(
          "gap-2 h-9 px-3 rounded-lg bg-primary/10 text-primary hover:bg-primary/20 hover:text-primary font-semibold text-sm",
          className,
        )}
      >
        {label}
        <Icon className="size-4" />
      </Button>
    );
  }

  // outline
  return (
    <Button
      variant="outline"
      onClick={onClick}
      className={cn(
        "gap-2 h-9 px-3 rounded-lg border-primary/40 text-primary hover:bg-primary/10 hover:text-primary font-semibold text-sm",
        className,
      )}
    >
      {label}
      <Icon className="size-4" />
    </Button>
  );
}
